import { TrackPreview } from '../../timeline/types';

/**
 * The Track field offers only the athlete's **single-athlete** tracks (and
 * single-athlete sub-tracks). A track is single-athlete when it has exactly one
 * member, and that member is the selected athlete. Sub-tracks are ordinary
 * tracks with a `parentTrackId`, so they pass the same predicate when they have
 * one member.
 */
export function singleAthleteTracksForAthlete(
  tracks: TrackPreview[],
  athleteId: string,
): TrackPreview[] {
  return tracks.filter(
    (track) =>
      track.athletes.length === 1 && track.athletes[0]?.profileId === athleteId,
  );
}
